import { TextFieldProps } from '@mui/material'
import { AddressSliceKey } from 'feature/addresses/hooks/useAddressState'
import { SavedAddress } from 'feature/addresses/redux/MyAddresses.api'
import { TSuggest } from 'feature/registration/types'
import { ScreenEnum, useScreen } from 'feature/screenMode'
import { FC, RefObject } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { DadataSelectInput } from 'widget/DadataSelectInput'

import styles from './AddressSelectInput.module.scss'
import { useAddressInput } from './useAddressInput'

interface IAddressSelectInput {
  className?: string
  onClick?: (ref: RefObject<HTMLDivElement>) => void
  onChange?: () => void
  onClickAway?: (e: MouseEvent | TouchEvent) => void
  onSelect?: (item: TSuggest) => void
  userAddressClick?: (address: SavedAddress) => void
  label?: string
  required?: boolean
  isUserAddressHidden?: boolean
  helperText?: string
  name?: string
  inputProps?: Partial<TextFieldProps> & { 'data-testid'?: string }
  addressKey?: AddressSliceKey
}

// обертка поля для выбора адреса
export const AddressSelectInput: FC<IAddressSelectInput> = ({
  className,
  onClick,
  onSelect,
  onClickAway,
  onChange,
  userAddressClick,
  required = true,
  label = 'Адрес',
  isUserAddressHidden = false,
  helperText = '',
  name = 'address',
  inputProps: externalInputProps,
  addressKey = 'default',
}) => {
  const {
    addressState: {
      inputSuggest,
      isError: isInputError,
      errorMessage: inputErrorMessage,
    },
    hasError,
    onClickAwayHandler,
    handleUserAddressClick,
    onSelectHook,
    setErrorAddress,
    clearErrorsAddress,
  } = useAddressInput(addressKey)

  const { control } = useFormContext()
  const screen = useScreen()

  return (
    <div className={className}>
      <Controller
        name={name}
        control={control}
        render={() => (
          <DadataSelectInput
            onClick={onClick}
            onSelect={e => {
              onSelectHook(e)
              onSelect?.(e)
            }}
            onChange={onChange}
            onClickAway={e => onClickAwayHandler(e, onClickAway)}
            clearErrorsAddress={clearErrorsAddress}
            setErrorAddress={setErrorAddress}
            userAddressClick={userAddressClick ?? handleUserAddressClick}
            inputProps={{
              type: 'text',
              multiline: true,
              label,
              required,
              error: hasError,
              helperText: hasError ? inputErrorMessage : helperText,
              maxRows: screen !== ScreenEnum.desktop ? 10 : 2,
              ...externalInputProps,
            }}
            isUserAddressHidden={isUserAddressHidden}
            addressKey={addressKey}
          />
        )}
      />
      {inputSuggest?.geoLat === null && !isInputError && (
        <div className={styles.notion}>
          Мы не смогли определить адрес на карте. Если адрес верный, вы можете
          продолжить работу.
        </div>
      )}
    </div>
  )
}
